import { AttributeModelState, MappingSetState, PackCalculatorState } from '../components/shared/types';

type RemovePackMapping = { mappingId: string };
type EditMappingSet = { field: string; value: string };
type EditMapping = { mappingId: string; field: string; value: string | string[] };
type EditPackCalculator = { mappingId: string; field: string; value: string };
type EditPackCalculatorInList = { mappingId: string; calculatorIndex: number; field: string; value: string };
type AddPackCalculatorToList = { mappingId: string; packCalculator: PackCalculatorState };
type RemovePackCalculatorFromList = { mappingId: string; calculatorIndex: number };
type MoveMainPackCalculatorToList = { mappingId: string };
type RehydrateAttributeModel = { mappingId: string; data: AttributeModelState };
type RehydratePackCalculatorList = { mappingId: string; packCalculatorList: PackCalculatorState[] };
type UpdateTestKey = { mappingIndex: number; mainKey: string; listKeys: string[] };

export type Action =
  | { type: 'ADD_PACK_MAPPING' }
  | { type: 'REMOVE_PACK_MAPPING'; payload: RemovePackMapping }
  | { type: 'EDIT_MAPPING_SET'; payload: EditMappingSet }
  | { type: 'EDIT_MAPPING'; payload: EditMapping }
  | { type: 'EDIT_PACK_CALCULATOR'; payload: EditPackCalculator }
  | { type: 'EDIT_PACK_CALCULATOR_IN_LIST'; payload: EditPackCalculatorInList }
  | { type: 'ADD_PACK_CALCULATOR_TO_LIST'; payload: AddPackCalculatorToList }
  | { type: 'REMOVE_PACK_CALCULATOR_FROM_LIST'; payload: RemovePackCalculatorFromList }
  | { type: 'MOVE_MAIN_PACK_CALCULATOR_TO_LIST'; payload: MoveMainPackCalculatorToList }
  | { type: 'REHYDRATE_MAPPING_SET'; payload: MappingSetState }
  | { type: 'REHYDRATE_PACK_CALCULATOR'; payload: PackCalculatorState }
  | { type: 'REHYDRATE_PACK_CALCULATOR_LIST'; payload: RehydratePackCalculatorList }
  | { type: 'REHYDRATE_ATTRIBUTE_MODEL'; payload: RehydrateAttributeModel }
  | { type: 'UPDATE_TEST_KEY'; payload: UpdateTestKey };

export const addPackMapping = () => ({ type: 'ADD_PACK_MAPPING' as const });
export const removePackMapping = (payload: RemovePackMapping) => ({ type: 'REMOVE_PACK_MAPPING' as const, payload });
export const editMappingSet = (payload: EditMappingSet) => ({ type: 'EDIT_MAPPING_SET' as const, payload });
export const editMapping = (payload: EditMapping) => ({ type: 'EDIT_MAPPING' as const, payload });
export const editPackCalculator = (payload: EditPackCalculator) => ({ type: 'EDIT_PACK_CALCULATOR' as const, payload });
export const editPackCalculatorInList = (payload: EditPackCalculatorInList) => ({
  type: 'EDIT_PACK_CALCULATOR_IN_LIST' as const,
  payload,
});
export const addPackCalculatorToList = (payload: AddPackCalculatorToList) => ({
  type: 'ADD_PACK_CALCULATOR_TO_LIST' as const,
  payload,
});
export const removePackCalculatorFromList = (payload: RemovePackCalculatorFromList) => ({
  type: 'REMOVE_PACK_CALCULATOR_FROM_LIST' as const,
  payload,
});
export const moveMainPackCalculatorToList = (payload: MoveMainPackCalculatorToList) => ({
  type: 'MOVE_MAIN_PACK_CALCULATOR_TO_LIST' as const,
  payload,
});

export const rehydrateAttributeModel = (payload: RehydrateAttributeModel) => ({
  type: 'REHYDRATE_ATTRIBUTE_MODEL' as const,
  payload,
});
export const rehydrateMappingSet = (payload: MappingSetState) => ({ type: 'REHYDRATE_MAPPING_SET' as const, payload });
export const rehydratePackCalculator = (payload: PackCalculatorState) => ({
  type: 'REHYDRATE_PACK_CALCULATOR' as const,
  payload,
});
export const rehydratePackCalculatorList = (payload: RehydratePackCalculatorList) => ({
  type: 'REHYDRATE_PACK_CALCULATOR_LIST' as const,
  payload,
});
export const updateTestKey = (payload: UpdateTestKey) => ({
  type: 'UPDATE_TEST_KEY' as const,
  payload,
});
